var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var Svg20 = function Svg20(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.54 7.04a.65.65 0 0 1 .92 0L10 11.58l4.54-4.54a.65.65 0 1 1 .92.92l-5 5a.65.65 0 0 1-.92 0l-5-5a.65.65 0 0 1 0-.92Z",
    fill: "currentColor"
  })));
};

export { Svg20 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00LjU0MDM5IDcuMDQwMzhDNC43OTQyMyA2Ljc4NjU0IDUuMjA1NzggNi43ODY1NCA1LjQ1OTYzIDcuMDQwMzhMMTAgMTEuNTgwOEwxNC41NDA0IDcuMDQwMzhDMTQuNzk0MiA2Ljc4NjU0IDE1LjIwNTggNi43ODY1NCAxNS40NTk2IDcuMDQwMzhDMTUuNzEzNSA3LjI5NDIyIDE1LjcxMzUgNy43MDU3OCAxNS40NTk2IDcuOTU5NjJMMTAuNDU5NiAxMi45NTk2QzEwLjIwNTggMTMuMjEzNSA5Ljc5NDIzIDEzLjIxMzUgOS41NDAzOSAxMi45NTk2TDQuNTQwMzkgNy45NTk2MkM0LjI4NjU1IDcuNzA1NzggNC4yODY1NSA3LjI5NDIyIDQuNTQwMzkgNy4wNDAzOFoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";